module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKkAAAAMCAYAAAAZBJ1yAAAAAXNSR0IArs4c6QAAATlJREFUaEPtmaFuhEAQhv9lSQVJSUhwfYSauhaDRlQgcPVVLQ9DXX0dgpAKNOau7kwfoY4sgSaIhoUGUsSJ9q4JlxU7uB2S+We+/TMbFgZ6iIAiAuM4nrVtey+lvANw+VPGO+f8xbbtZ8bY1xRjiuojWc0JVFV1YRjGK4CrX1DshmG4dV33g0yquVlUtD9N0Lqu3/4w6FLWznGcazKpil3SXLNpmgcp5dOEoe97ZFmGsixnKr7vIwxDmKY5rznnj2RSzQ2jon0hxAbAzaSdpimKotgrIwgCRFG0xLYsz/NRRaGkqS8Bz/OmCTkDiOMYXdftwbAsC0mSLLFPmqT6ekVZ50KIFsA5mVTZFpDwIQL/Pu4PJaT3RGBtAvThtDZRyrc6AbqCWh0pJTwFAbrMPwVVyrk6gWN/i34Dko+HK+Y36vgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left.png
// module id = F0Yv
// module chunks = 1